import React, { useState } from 'react';
import { Box } from '@mui/material';
import { pick } from 'lodash-es';

import { showError } from '@utils';
import { useToggleModal } from '@hooks';
import { customerVehiclesServices } from '@services';

import { PermissionsGate } from 'components/common';
import { EditIcon, IconButtonV2 } from 'components/common/ui';
import { ModalFormSection, ModalV2, Tooltip } from 'components/common/modals';
import { ENTITIES_PERMISIONS } from 'components/common/PermissionsGate/constants';

import EditVehicleInfoForm from './EditVehicleInfoForm';
import { FORM_KEYS } from './constants';
import { sanitizeFormData } from './utils';

const EditVehicleInfoModal = ({
  details,
  dataLoading,
  onGetCustomerVehicle,
}) => {
  const [loading, setLoading] = useState(false);

  const { isOpen, handleOpen, handleClose } = useToggleModal();

  const customerVehicleId = details.id;

  const defaultValues = sanitizeFormData(pick(details, FORM_KEYS));

  const handleSubmit = async (values) => {
    if (values.type) {
      delete values.type;
    }

    if (values.year) {
      values.year = Number(values.year);
    }

    const payload = {
      ...values,
      mileage: Number(values.mileage),
    };
    try {
      setLoading(true);
      await customerVehiclesServices.editCustomerVehicle(
        customerVehicleId,
        payload
      );
      await onGetCustomerVehicle();
      handleClose();
    } catch (error) {
      showError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PermissionsGate entity={ENTITIES_PERMISIONS.WriteCustomerVehicles}>
        <IconButtonV2
          variant="text"
          size="small"
          disabled={dataLoading}
          onClick={handleOpen}
        >
          <Tooltip title="Edit Vehicle Info" placement="top">
            <Box component="span" sx={{ display: 'flex', mb: '2px' }}>
              <EditIcon />
            </Box>
          </Tooltip>
        </IconButtonV2>
      </PermissionsGate>
      {isOpen && (
        <ModalV2
          isOpen={isOpen}
          onClose={handleClose}
          isLoading={loading}
          title="Update Vehicle Info"
          maxWidth="lg"
        >
          <ModalFormSection>
            <EditVehicleInfoForm
              defaultValues={defaultValues}
              onCancel={handleClose}
              onSubmit={handleSubmit}
            />
          </ModalFormSection>
        </ModalV2>
      )}
    </>
  );
};

export default EditVehicleInfoModal;
